import logoVacuum from "../assets/images/coverimage-5.png";
import logoCeam from "../assets/lab/logoCeam.png";
import logoGnessin from "../assets/lab/logoGnessin.jpg";
import { TPartner } from "./types";

export const partners: TPartner[] = [
  {
    id: 1,
    name: "Струнный квартет Vacuum",
    description:
      'Был основан в 2016 году в Московской государственной консерватории. В 2020 году ансамбль сменил свое название на "Vacuum Quartet" и с тех пор специализируется на исполнении и популяризации произведений новейшей квартетной музыки. В их репертуар входят сочинения композиторов второй половины XX — начала XXI века. За время своего существования Vacuum Quartet принял участие в многочисленных фестивалях в России и за ее пределами, исполнил множество мировых и российских премьер.С 2021 года лейбл "Fancy Music" выпустил записи струнных квартетов Алексея Сысоева, Дмитрия Курляндского и Александра Хубеева, записанные Vacuum Quartet.',
    photo: logoVacuum,
  },
  {
    id: 2,
    name: "Центр электроакустической музыки (ЦЭАМ)",
    description:
      "Подразделение Московской консерватории, образованное в 2006 году. Развивается в нескольких направлениях: творческом, научном, образовательном и просветительском. Центром руководит композитор Николай Попов. ЦЭАМ организует фестивали, конференции, концерты, выставки, спектакли, перформансы, а также экспериментирует с просветительскими форматами. В 2023 году ЦЭАМ курирует программу событий в Арт-пространстве Артемьев. Здесь проходят выставки аудиовизуальных произведений, а также концерты, лекции и мастер-классы.",
    photo: logoCeam,
  },
  {
    id: 3,
    name: "Gnesin Contemporary Music Week",
    description:
      "фестиваль современной музыки и образовательная площадка для молодых музыкантов, который проходит в Москве с 2018 года. Некоторые форматы и направления фестиваля: междисциплинарные исследования; воркшопы по исполнению и анализу современных произведений; дизайн концертов; цифровые творческие проекты.",
    photo: logoGnessin,
  },
];
